import React from 'react';
import { Helmet } from "react-helmet";
import { FaHashtag, FaUsers, FaChartBar, FaBullseye, FaHandshake } from 'react-icons/fa';
import "./InfluencerMarketing.css";

const InfluencerMarketing = () => {
  return (
    <main className="service-page">
      <Helmet>
        <title>Influencer Marketing Services | Skyline Bussiness Solutions</title>

        <meta 
          name="description" 
          content="Grow your brand with influencer marketing services by Skyline Bussiness Solutions. We connect brands with high-authority creators to boost reach, engagement, and ROI." 
        />

        {/* ✅ Canonical URL */}
        <link 
          rel="canonical" 
          href="https://skylinebussinesssolutions.com/influencer-marketing" 
        />
      </Helmet>

      {/* HERO */}
      <header className="service-hero">
        <div className="service-hero-content">
          <span className="service-badge">SOCIAL AUTHORITY</span>

          <h1 className="service-display">
            Influencer <br />
            <span className="accent-text">Marketing Hub</span>
          </h1>

          <p className="service-intro">
            At <strong>Skyline Bussiness Solutions</strong>, we connect your brand with
            trusted creators who already influence your target audience and drive real results.
          </p>
        </div>
      </header>

      <div className="service-container">

        {/* STRATEGY */}
        <section className="strategy-section">
          <div className="strategy-card">
            <div className="strat-icon"><FaBullseye /></div>
            <h3>Micro-Targeting</h3>
            <p>Reach niche audiences through high-engagement creators.</p>
          </div>

          <div className="strategy-card">
            <div className="strat-icon"><FaHashtag /></div>
            <h3>Trend Strategy</h3>
            <p>We align campaigns with viral trends and platform algorithms.</p>
          </div>

          <div className="strategy-card">
            <div className="strat-icon"><FaHandshake /></div>
            <h3>Creator Partnerships</h3>
            <p>Long-term influencer collaborations for sustainable growth.</p>
          </div>
        </section>

        {/* SERVICES */}
        <section className="capabilities-grid">
          <div className="glass-card">
            <FaUsers className="card-icon" />
            <h3>Creator Discovery</h3>
            <p>Find influencers based on audience data and performance.</p>
          </div>

          <div className="glass-card">
            <FaChartBar className="card-icon" />
            <h3>Performance Tracking</h3>
            <p>Track clicks, impressions, and ROI in real-time.</p>
          </div>

          <div className="glass-card">
            <FaBullseye className="card-icon" />
            <h3>Campaign Execution</h3>
            <p>Launch and scale campaigns for maximum reach.</p>
          </div>
        </section>

        {/* WORKFLOW */}
        <section className="workflow-section">
          <div className="section-header">
            <h2>Campaign Process</h2>
            <div className="line"></div>
          </div>

          <div className="workflow-steps">
            <div className="step">
              <span>01</span>
              <h4>Research</h4>
              <p>Identify ideal influencers for your niche.</p>
            </div>

            <div className="step">
              <span>02</span>
              <h4>Execution</h4>
              <p>Launch influencer campaigns with strong creatives.</p>
            </div>

            <div className="step">
              <span>03</span>
              <h4>Scaling</h4>
              <p>Scale campaigns based on performance data.</p>
            </div>
          </div>
        </section>
      </div>

      {/* SCHEMA */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Influencer Marketing Services",
          "provider": {
            "@type": "Organization",
            "name": "Skyline Bussiness Solutions",
            "url": "https://skylinebussinesssolutions.com"
          },
          "description": "Influencer marketing services including creator outreach, campaign management, and analytics."
        })}
      </script>
    </main>
  );
};

export default InfluencerMarketing;